module.exports = __webpack_public_path__ + "static/media/delete-white.42654fe8.svg";